import {
  IRichTextEditorProps,
  RichTextEditor,
  transformTextToNewEditor,
} from 'core-components/library/richTextEditor'

import { IRenderCustomSettingsParams } from '../../flexItem/models/IRenderCustomContent'
import styles from '../SettingsStyles.module.scss'

interface IBasicSettingsStaticProps extends IRenderCustomSettingsParams {
  fileUploadAdapter?: IRichTextEditorProps['fileUploadAdapter']
}

export const BasicSettingsStatic = ({
  widget,
  onChangeField,
  fileUploadAdapter,
}: IBasicSettingsStaticProps) => {
  const preparedContent = transformTextToNewEditor(widget.content)

  return (
    <div>
      <RichTextEditor
        classes={{ root: styles.lineElement }}
        value={preparedContent}
        onChange={(value) => onChangeField('content', value)}
        fileUploadAdapter={fileUploadAdapter}
      />
    </div>
  )
}
